import React from 'react';
import {
  IntroContent,
  IntroDescription,
  IntroHeader,
  IntroIcon,
  IntroShell,
  IntroTitle,
  IntroBadge,
  PageActions,
  PageLayout,
  PagePanel,
} from './styles';

interface PageIntroProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  badge?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
}

export const PageIntro: React.FC<PageIntroProps> = ({
  title,
  description,
  badge,
  icon,
  actions,
}) => {
  return (
    <IntroShell>
      <IntroHeader>
        {icon ? <IntroIcon>{icon}</IntroIcon> : null}
        <IntroContent>
          {badge ? <IntroBadge>{badge}</IntroBadge> : null}
          <IntroTitle>{title}</IntroTitle>
          {description ? (
            <IntroDescription>{description}</IntroDescription>
          ) : null}
        </IntroContent>
      </IntroHeader>
      {actions ? <PageActions>{actions}</PageActions> : null}
    </IntroShell>
  );
};

export { PageLayout, PagePanel };
